module.exports = "/src/views/player/documets/lspdbadge/images/ava.png";